import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class StateDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  deleteStateAsync(id: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('States/Delete', id, timeout);
  }

  checkStateExistsAsync(code: string, countryId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { code: code, countryId: countryId, id: id };
    return this.httpClient.getJsonAsync<boolean>('States/CheckStateExists', data, timeout, false);
  }
}
